import { useCallback, useEffect, useState } from 'react';
import { Token } from 'shared/types/Token';
import { BankDetails } from 'shared/types/cart';
import { sdk } from 'sdk';
import { CheckoutCartPayload } from 'sdk/composable-commerce/types/payloads/CartPayloads';

const useCheckout = () => {
  const [session, setSession] = useState<Token>();
  const [isExpired, setIsExpired] = useState(false);

  useEffect(() => {
    sdk.composableCommerce.cart.getCheckoutSessionToken().then((res) => {
      if (!res.isError) setSession(res.data);
      else setIsExpired(true);
    });
  }, []);

  const checkoutComplete = useCallback(async (orderId: string) => {
    await sdk.callAction({ actionName: `cart/checkoutComplete?orderId=${orderId}` });
  }, []);

  const checkout = useCallback(async (data: CheckoutCartPayload) => {
    const extensions = sdk.composableCommerce;

    const res = await extensions.cart.checkout(data);

    return res.isError ? { error: res.error, success: false } : { ...res.data, success: true };
  }, []);

  return { session, isExpired, checkoutComplete, checkout };
};

export default useCheckout;
